<div
  class="absolute h-screen w-screen bg-cover bg-center"
  style="background-image: url('assets/woordkr8/backgrounds/login-background.png')"
></div>

<!-- black background overlay -->
<div class="absolute inset-0 bg-black/50"></div>

<div class="relative grid h-dvh place-items-center">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="mx-auto flex w-full max-w-md flex-col items-center justify-center gap-4 px-4">
    <app-portal-panel class="w-[800px]">
      <div class="flex flex-col gap-5">
        <div class="barlow-regular text-center text-4xl text-white">
          <span> Scan de QR code of voer de code handmatig in om een </span> <span class="font-bold">klas te importeren.</span>
        </div>
        <div class="flex flex-row items-center gap-2">
          <app-portal-input
            id="code"
            class="flex-auto"
            ngDefaultControl
            formControlName="code"
            placeholder="XXXX-XXXX-XXXX"
          ></app-portal-input>
          <button appPortalButton [disabled]="form.invalid" class="barlow-regular w-1/5 p-2" type="submit">
            <span class="barlow-regular text-2xl">OK</span>
          </button>
        </div>
        <button (click)="scanQrCode()" class="barlow-regular p-2 text-2xl" appPortalButton color="blue" type="button">
          Scan met camera
        </button>
      </div>
    </app-portal-panel>
  </form>
</div>

<!-- Player group import success message -->
@if (showSuccessMessage()) {
  <div class="success-overlay absolute inset-0 z-50 flex items-center justify-center bg-black/70">
    <app-portal-panel color="green" class="success-panel max-w-xl min-w-sm">
      <div class="barlow-semi-condensed-bold size-full p-4 text-center text-6xl text-white">Klas geïmporteerd!</div>
    </app-portal-panel>
  </div>
}
